import { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import { Auth0ProviderOptions } from '@auth0/auth0-react';

import { Auth0Provider } from '@auth0/auth0-react';
import { safeReturnTo } from './login-options';

const Auth0ProviderWithRedirectCallback = ({
  children,
  ...props
}: PropsWithChildren<Auth0ProviderOptions>) => {
  const navigate = useNavigate();
  const onRedirectCallback = (appState: any) => {
    // returnTo comes back from the login round trip, so it is checked again where the redirect happens.
    navigate(safeReturnTo(appState?.returnTo ?? window.location.pathname));
  };

  return (
    <Auth0Provider onRedirectCallback={onRedirectCallback} {...props}>
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithRedirectCallback;
